<template>
  <div class="component-layer" v-if="value">
    <div class="content">
      <div class="close iconfont icon_cancle_round" @click="close"></div>
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  props: ['value'],
  data () {
    return {}
  },
  components: {},
  computed: {},
  methods: {
    close () {
      this.$emit('input', false)
    }
  },
  watch: {},
  created () {
  },
  mounted () {
  }
}
</script>
<style lang="stylus" type="text/stylus" scoped>
.content
  position absolute
  width 2.7rem
  left 50%
  top 40%
  transform translate(-50%, -50%)
  .close
    position absolute
    width .36rem
    height .36rem
    left 50%
    bottom -.51rem
    margin-left -.18rem
    color rgba(255, 255, 255, .4)
    font-size .36rem
    text-align center
    line-height 1
    font-weight 300
.component-layer
  position fixed
  width 100%
  height 100%
  left 0
  top 0
  background rgba(0, 0, 0, .6)
</style>
